import { Button } from "antd";

import { FC, useEffect, useState } from 'react';
import fullScreen from '../../assets/fullScreen.svg';
import popoverScreen from '../../assets/popoverScreen.svg';
import popupScreen from '../../assets/popupScreen.svg';
import sideTabScreen from '../../assets/sideTabScreen.svg';
import sliderScreen from '../../assets/sliderScreen.svg';
import standardScreen from '../../assets/standardScreen.svg';
import { EmbeddingProps } from "../../pages/Embedding/interface";
import { HeaderContainer } from '../ContentCard/styled';
import { WidgetConfigProps } from "../EmbeddingForm/types";
import PopoverScreenComponent from '../EmbeddingPopoverScreen';
import PopupScreenComponent from '../EmbeddingPopupScreen';
import SideTabScreenComponent from "../EmbeddingSideTAbScreen";
import SliderScreenComponent from '../EmbeddingSliderScreen';
import StandardScreenComponent from '../EmbeddingStandardScreen';
import { CustomButton } from "../Custom/Buttons";
import './style.scss';
import { handleApplyChanges } from "../EmbeddingSideTab/constant";
import { Alert, Box } from "@mui/material";
import CustomLoader from "../Custom/CustomLoader";

interface EmbeddingModeTabProps extends EmbeddingProps {
  setWidgetConfigDetails: (data: WidgetConfigProps) => void;
  widgetConfigDetails: WidgetConfigProps;
  selectedEmbed: any;
  embedResponse: any[];
  fetchEmbed: any;
  alertOpen: boolean;
  setAlertOpener: any
}

const EmbeddingModeTab: FC<EmbeddingModeTabProps> = ({ editUUID, setWidgetConfigDetails, widgetConfigDetails, selectedEmbed, embedResponse, fetchEmbed, alertOpen, setAlertOpener }) => {

  const [embedMode, setEmbedMode] = useState("standard-screen")
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (widgetConfigDetails?.mode) {
      setEmbedMode(widgetConfigDetails?.mode)
    }
  }, [widgetConfigDetails])

  return (
    <div className="rightSideTab">
      <div>
        <div className="applyChange">
          <HeaderContainer>Design</HeaderContainer>
          <CustomButton className="applyChangeButton" text="Apply Changes" onClick={() => handleApplyChanges(embedResponse, editUUID, selectedEmbed, fetchEmbed, setAlertOpener, setLoading)} />
        </div>
        <HeaderContainer>Embed mode</HeaderContainer>
      </div>
      <div className="embeddingFormMode">
        <Button title="Standard Screen" onClick={() => { setEmbedMode("standard-screen"); if (widgetConfigDetails.mode !== "standard-screen") { setWidgetConfigDetails({ mode: "standard-screen" }) } }} style={{ borderWidth: embedMode === "standard-screen" ? "3px" : "1px" }} id="standardScreen" className="embeddingModeBUtton"><img className="embedImage" src={standardScreen} alt="" />
        </Button>
        <Button title="Full-Screen" onClick={() => { setEmbedMode("full-screen"); if (widgetConfigDetails.mode !== "full-screen") { setWidgetConfigDetails({ mode: "full-screen" }) } }} style={{ borderWidth: embedMode === "full-screen" ? "3px" : "1px" }} id="fullScreen" className='embeddingModeBUtton'><img className='embedImage' src={fullScreen} alt="" />
        </Button>
        <Button title="Popup" onClick={() => { setEmbedMode("popup"); if (widgetConfigDetails.mode !== "popup") { setWidgetConfigDetails({ mode: "popup" }) } }} style={{ borderWidth: embedMode === "popup" ? "3px" : "1px" }} id="popupScreen" className='embeddingModeBUtton'><img className='embedImage' src={popupScreen} alt="" />
        </Button>
        <Button title="Slider" onClick={() => { setEmbedMode("slider"); if (widgetConfigDetails.mode !== "slider") { setWidgetConfigDetails({ mode: "slider" }) } }} style={{ borderWidth: embedMode === "slider" ? "3px" : "1px" }} id="sliderScreen" className='embeddingModeBUtton'><img className='embedImage' src={sliderScreen} alt="" />
        </Button>
        <Button title="Popover" onClick={() => { setEmbedMode("popover"); if (widgetConfigDetails.mode !== "popover") { setWidgetConfigDetails({ mode: "popover" }) } }} style={{ borderWidth: embedMode === "popover" ? "3px" : "1px" }} id="popoverScreen" className='embeddingModeBUtton'><img className='embedImage' src={popoverScreen} alt="" />
        </Button>
        <Button title="Side Tab" onClick={() => { setEmbedMode("side-tab"); if (widgetConfigDetails.mode !== "side-tab") { setWidgetConfigDetails({ mode: "side-tab" }) } }} style={{ borderWidth: embedMode === "side-tab" ? "3px" : "1px" }} id="sideTabScreen" className='embeddingModeBUtton'><img className='embedImage' src={sideTabScreen} alt="" />
        </Button>
      </div>
      <p>Settings</p>
      <hr />
      <div className='embedModeScreenType'>
        {embedMode === "standard-screen" && <StandardScreenComponent setWidgetConfigDetails={setWidgetConfigDetails} widgetConfigDetails={widgetConfigDetails} />}
        {embedMode === "popup" && <PopupScreenComponent setWidgetConfigDetails={setWidgetConfigDetails} widgetConfigDetails={widgetConfigDetails} />}
        {embedMode === "popover" && <PopoverScreenComponent editUUID={editUUID} setWidgetConfigDetails={setWidgetConfigDetails} widgetConfigDetails={widgetConfigDetails} />}
        {embedMode === "side-tab" && <SideTabScreenComponent editUUID={editUUID} setWidgetConfigDetails={setWidgetConfigDetails} widgetConfigDetails={widgetConfigDetails} />}
        {embedMode === "slider" && <SliderScreenComponent editUUID={editUUID} setWidgetConfigDetails={setWidgetConfigDetails} widgetConfigDetails={widgetConfigDetails} />}
      </div>
      <div className="alertContainer">
        <>
          {loading && (
            <Box
              component="div"
              height="100vh"
              width="100vw"
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 999,
                opacity: 1,
                transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <CustomLoader />
            </Box>
          )}

          {alertOpen && (
            <Alert
              variant="filled"
              onClose={() => {
                setAlertOpener(false);
              }}
              sx={{
                position: "fixed",
                bottom: "16px",
                right: "16px",
                zIndex: 10000,
              }}
            >
              Updated successfully
            </Alert>
          )}
        </>
      </div>
    </div>
  )
}
export default EmbeddingModeTab 